import Icon from '@ant-design/icons';
import { Button, Col, Flex, Row, Spin } from 'antd';
import { notifyError, priceFormat } from '../../store/utils';
import MobileStep from './lib/MobileStep';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { API } from '../../api';
import { isMobile } from 'react-device-detect';
import { banks } from '../../common/banks';

interface State {
  loading: boolean;
  payment?: any;
}

const Payment = () => {
  const navigate = useNavigate();
  const { paymentNo } = useParams();
  const [state, setState] = useState<State>({ loading: true });

  const fetchPayment = useCallback(async (no: string) => {
    try {
      const {
        result: { data },
      } = await API.get({ apiVersion: 'api' })(`/customer-order/payment/${no}`);
      setState({ loading: false, payment: data });
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  useEffect(() => {
    if (paymentNo) fetchPayment(paymentNo);
  }, [paymentNo]);

  useEffect(() => {
    if (!paymentNo) return;
    const interval = setInterval(() => {
      fetchPayment(paymentNo);
    }, 3000);

    return () => clearInterval(interval);
  }, [paymentNo]);

  return (
    <div style={{ background: '#FFF' }}>
      <MobileStep current={3} />
      <div style={{ padding: 24 }}>
        {state.loading ? (
          <Flex style={{ height: 200 }} justify="center" align="center">
            <Spin />
          </Flex>
        ) : (
          <Row className="payment">
            {(state?.payment.status || {}).code === 'PENDING' ? (
              <Col span={24}>
                <h3>
                  Та дараах баркодыг уншуулж дурын банкны QPAY үйлчилгээгээр төлбөрөө төлнө үү
                </h3>
                <div className="barcode">
                  {isMobile ? (
                    <div className="mobile-banks">
                      {banks.map((bank: any, index: number) => {
                        return (
                          <a
                            className="bank-item"
                            href={`${bank.link}${state?.payment?.code}`}
                            key={`bank_${index}`}
                          >
                            <div
                              className="bank-icon"
                              style={{ backgroundImage: `url("${bank.image}")` }}
                            />
                            <div className="bank-title">{bank.name}</div>
                          </a>
                        );
                      })}
                    </div>
                  ) : (
                    <a href={state?.payment?.link}>
                      <img
                        src={`data:image/jpeg;base64,${state?.payment?.image}`}
                        width={200}
                        height={200}
                      />
                    </a>
                  )}
                  <ul>
                    <li>
                      <b>Захиалгын дугаар:</b>{' '}
                      {(state?.payment?.orders || []).map((order: any) => order.no).join(', ')}
                    </li>
                    <li>
                      <b>Огноо:</b> {dayjs(state?.payment?.createdAt).format('YYYY-MM-DD')}
                    </li>
                    <li>
                      <b>Төлөх дүн:</b> {priceFormat(state?.payment?.amount)}₮
                    </li>
                  </ul>
                </div>
                <div>
                  <div style={{ textAlign: 'center' }}>
                    Төлбөрийг{' '}
                    <span style={{ color: 'red' }}>
                      {dayjs(state?.payment?.createdAt)
                        .add(30, 'minutes')
                        .format('YYYY-MM-DD HH:mm')}
                    </span>{' '}
                    хүртэл төлбөр төлөөгүй бол <br /> захиалга автоматаар цуцлагдахыг анхаарна уу!
                  </div>
                </div>
                <div className="contact">
                  <h3>Холбоо барих:</h3>
                  <p>Утас: 77078912</p>
                  <p>
                    Мэйл хаяг: <a href="mailto:logistics@mongolpost.mn">logistics@mongolpost.mn</a>
                  </p>
                </div>
              </Col>
            ) : null}
            {(state?.payment?.status || {}).code === 'DELETED' ? (
              <Col span={12} offset={6} className="complete">
                <h2 className="sub-header">Захиалгын мэдээлэл</h2>
                <h3 style={{ color: 'red' }}>
                  <Icon type="exclamation-circle" />
                  Төлбөр төлөх хугацаа дуусан
                </h3>
                <ul>
                  <li>
                    <b>Захиалгын дугаар:</b>{' '}
                    {(state?.payment?.orders || []).map((order: any) => order.no).join(', ')}
                  </li>
                  <li>
                    <b>Огноо:</b> {dayjs(state?.payment?.createdAt).format('YYYY-MM-DD')}
                  </li>
                </ul>
                <h2 className="sub-header">Холбоо барих</h2>
                <div className="order">
                  <Row gutter={8}>
                    <Col span={12}>
                      <ul>
                        <li>
                          <b>Утас:: </b>77078912
                        </li>
                        <li>
                          <b>Мэйл хаяг: </b>
                          <a href="mailto:logistics@mongolpost.mn">logistics@mongolpost.mn</a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
                <Button type="primary" onClick={() => navigate('/customer-order')}>
                  Буцах
                </Button>
              </Col>
            ) : null}
            {(state?.payment?.status || {}).code === 'REJECTED' ? (
              <Col span={12} offset={6} className="complete">
                <h2 className="sub-header">Захиалгын мэдээлэл</h2>
                <h3 style={{ color: 'red' }}>
                  <Icon type="exclamation-circle" />
                  Төлбөр цуцлагдсан
                </h3>
                <ul>
                  <li>
                    <b>Захиалгын дугаар:</b>{' '}
                    {(state?.payment?.orders || []).map((order: any) => order.no).join(', ')}
                  </li>
                  <li>
                    <b>Огноо:</b> {dayjs(state?.payment?.createdAt).format('YYYY-MM-DD')}
                  </li>
                </ul>
                <h2 className="sub-header">Холбоо барих</h2>
                <div className="order">
                  <Row gutter={8}>
                    <Col span={24}>
                      <ul>
                        <li>
                          <b>Утас:: </b>77078912
                        </li>
                        <li>
                          <b>Мэйл хаяг: </b>
                          <a href="mailto:logistics@mongolpost.mn">logistics@mongolpost.mn</a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
                <Button type="primary" onClick={() => navigate('/customer-order')}>
                  Буцах
                </Button>
              </Col>
            ) : null}
            {(state?.payment?.status || {}).code === 'ACTIVE' ? (
              <Col span={12} offset={6} className="complete">
                <h2 className="sub-header">Захиалгын мэдээлэл</h2>
                <h3 style={{ color: 'green' }}>
                  <Icon type="check-circle" />
                  Таны захиалга амжилттай хийгдлээ
                </h3>
                <ul>
                  <li>
                    <b>Огноо:</b> {dayjs(state?.payment?.createdAT).format('YYYY-MM-DD')}
                  </li>
                </ul>
                <h2 className="sub-header">Хүргэлтийн мэдээлэл</h2>
                {(state?.payment.orders || []).map((order: any, index: number) => {
                  return (
                    <div key={order.no} className="order">
                      <div style={{ textAlign: 'center' }}>
                        <b>Захиалгын дугаар: {order.no}</b>
                      </div>
                      <Row gutter={8}>
                        <Col span={12}>
                          <ul>
                            <li>
                              <b>Илгээгч нэр: </b>
                              {order.senderFname}
                            </li>
                            <li>
                              <b>Илгээх хаяг: </b>
                              {order.senderAddress}
                            </li>
                            <li>
                              <b>Илгээгч утас: </b>
                              {order.senderPhone}
                            </li>
                            {(order?.items || []).map((item: any, idx: number) => {
                              return (
                                <ul key={`order_${index}_item_${idx}`}>
                                  <li>
                                    <b>Нэр төрөл: </b>
                                    {item.itemType}
                                  </li>
                                  <li>
                                    <b>Илгээмжийн тоо: </b>1
                                  </li>
                                  <li>
                                    <b>Хэмжээ: </b>
                                    {(item.weightType || {}).name}
                                  </li>
                                  <li>
                                    <b>Анхаарах зүйлс: </b>
                                    {(item.warning || {}).name}
                                  </li>
                                </ul>
                              );
                            })}
                          </ul>
                        </Col>
                        <Col span={12}>
                          <ul>
                            <li>
                              <b>Хүлээн авагч нэр: </b>
                              {order.receiverFname}
                            </li>
                            <li>
                              <b>Хүргэх хаяг: </b>
                              {order.receiverAddress}
                            </li>
                            <li>
                              <b>Хүлээн авагч утас: </b>
                              {order.receiverPhone}
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
                <h2 className="sub-header">Холбоо барих</h2>
                <div className="order">
                  <Row gutter={8}>
                    <Col span={24}>
                      <ul>
                        <li>
                          <b>Утас:: </b>77078912
                        </li>
                        <li>
                          <b>Мэйл хаяг: </b>
                          <a href="mailto:logistics@mongolpost.mn">logistics@mongolpost.mn</a>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </div>
                <h2 className="sub-header">Зөвлөгөө!</h2>
                <Row gutter={8}>
                  <Col span={12}>
                    <ul>
                      <li style={{ marginTop: 50 }}>
                        Та илгээмжээ тээвэрлэлтийн явцад эвдэрч, гээгдэхээс урьдчилан хамгаалж
                        сайтар байрлаж бэлтгэнэ үү!
                      </li>
                    </ul>
                  </Col>
                  <Col span={12}>
                    <img width={130} src="/images/box.png" />
                  </Col>
                </Row>
                <Button
                  type="primary"
                  style={{ marginTop: 20, marginBottom: 20 }}
                  onClick={() => navigate('/customer-order')}
                >
                  Буцах
                </Button>
              </Col>
            ) : null}
          </Row>
        )}
      </div>
    </div>
  );
};

export default Payment;
